import { addDays, addHours } from 'date-fns'
import { Campaign, InAppTemplateData } from '../../types'
import { parseUtcDate } from '../../utils'

const DEFAULT_WINDOW_DAYS = 7
const USER_TIMEZONE_SPREAD_HOURS = 26

export const isInAppBroadcast = (campaign: Pick<Campaign, 'channel' | 'type' | 'settings'>) =>
    campaign.channel === 'in_app'
    && campaign.type === 'blast'
    && campaign.settings?.in_app_delivery === 'broadcast'

export const derivedEndsAt = (campaign: Pick<Campaign, 'templates'>, sendAt: Date): { date: Date, source: 'message' | 'default' } => {
    const expiries = (campaign.templates ?? [])
        .map(template => template.data as InAppTemplateData)
        .map(data => {
            const expiresAt = parseUtcDate(data?.expires_at)
            return expiresAt && data.expires_in_user_timezone ? addHours(expiresAt, USER_TIMEZONE_SPREAD_HOURS) : expiresAt
        })
        .filter((date): date is Date => date != null)
    if (expiries.length) return { date: new Date(Math.max(...expiries.map(date => date.getTime()))), source: 'message' }
    return { date: addDays(sendAt, DEFAULT_WINDOW_DAYS), source: 'default' }
}
